import React from 'react';
import { Link } from 'react-router-dom';

export const JoinUs = ({ title, text, buttonText, link }) => (
	<section className="call-to-action">
		<div className="auto-container">
			<h2>{title}</h2>
			<div className="text">{text}</div>
			<div className="link-box"><Link to={link} className="theme-btn btn-style-six">{buttonText}</Link></div>
		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/components/ui/JoinUs/JoinUs.js